// frontend/admin-portal/src/services/goodsReceiptService.js
import api from './axiosConfig';

export const goodsReceiptService = {
    list: async (params = {}) => {
        const { data } = await api.get('/goods-receipts', { params });
        return data.data;
    },
    get: async (id) => {
        const { data } = await api.get(`/goods-receipts/${id}`);
        return data.data.receipt;
    },
    cancel: async (id) => {
        const { data } = await api.patch(`/goods-receipts/${id}/cancel`);
        return data;
    },
};